module.exports = __webpack_public_path__ + "static/media/download-02.4e4ac709.svg";